import { Controller } from "@hotwired/stimulus"

// Swaps the "change my password" prompt for the password fields.
// Attached to the prompt block; the fields live in #change-user-password-inputs.
export default class extends Controller {
  reveal() {
    this.element.classList.add("d-none")
    document.getElementById("change-user-password-inputs").classList.remove("d-none")
  }
}
